import { forwardRef, type ReactElement, type Ref } from 'react';
import cx from 'clsx';
import {
  Popover as AriaPopover,
  type PopoverProps as AriaPopoverProps,
} from 'react-aria-components';
import styles from './popover.module.css';

export type PopoverProps = AriaPopoverProps & { ref?: Ref<HTMLElement> };

export const Popover = forwardRef<HTMLElement, PopoverProps>(function Popover(
  { className, placement = 'bottom start', offset = 8, crossOffset = 0, ...props },
  ref
): ReactElement {
  return (
    <AriaPopover
      ref={ref}
      className={cx(styles.popover, className)}
      crossOffset={crossOffset}
      offset={offset}
      placement={placement}
      {...props}
    />
  );
});
